var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-time-picker',{attrs:{"allowed-hours":_vm.allowedHours,"allowed-minutes":_vm.allowedMinutes,"format":"24hr","scrollable":"","min":"9:30","max":"22:15","color":"primary"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }